module.exports = __webpack_public_path__ + "fonts/Rubik-500-arabic70.d2ec738.woff2";